var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
let VitesseRadioGroup = class VitesseRadioGroup extends LitElement {
    constructor() {
        super(...arguments);
        this.options = [];
        this.value = '';
        this.disabled = false;
        this.layout = 'row';
    }
    static { this.styles = css `
    :host {
      display: block;
    }
    .group {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
    }
    :host([layout='column']) .group {
      flex-direction: column;
    }
    .opt {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      padding: 8px 12px;
      border: 1px solid var(--border-color-light);
      border-radius: var(--radius, 6px);
      background: var(--bg-tertiary);
      color: var(--text-primary);
      cursor: pointer;
      font: inherit;
      font-size: 14px;
      transition:
        border-color 0.18s ease,
        color 0.18s ease;
    }
    .opt:hover:not(.checked) {
      border-color: var(--blue);
    }
    .opt.checked {
      border-color: var(--blue);
      color: var(--blue);
    }
    .dot {
      width: 14px;
      height: 14px;
      border-radius: 50%;
      border: 1px solid var(--border-color-light);
      flex-shrink: 0;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      transition: border-color 0.18s ease;
    }
    .opt.checked .dot {
      border-color: var(--blue);
    }
    .opt.checked .dot::after {
      content: '';
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: var(--blue);
    }
    :host([disabled]) .group {
      opacity: 0.55;
      pointer-events: none;
    }
  `; }
    pick(v) {
        if (this.disabled)
            return;
        this.value = v;
        this.dispatchEvent(new CustomEvent('change', { detail: { value: v }, bubbles: true, composed: true }));
    }
    render() {
        return html `<div class="group" role="radiogroup">
      ${this.options.map((o) => html `<button
          type="button"
          role="radio"
          aria-checked=${o.value === this.value}
          class="opt ${o.value === this.value ? 'checked' : ''}"
          @click=${() => this.pick(o.value)}
        >
          <span class="dot"></span><span>${o.label}</span>
        </button>`)}
    </div>`;
    }
};
__decorate([
    property({ attribute: false })
], VitesseRadioGroup.prototype, "options", void 0);
__decorate([
    property()
], VitesseRadioGroup.prototype, "value", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], VitesseRadioGroup.prototype, "disabled", void 0);
__decorate([
    property({ reflect: true })
], VitesseRadioGroup.prototype, "layout", void 0);
VitesseRadioGroup = __decorate([
    customElement('vitesse-radio-group')
], VitesseRadioGroup);
export { VitesseRadioGroup };
//# sourceMappingURL=vitesse-radio-group.js.map